<template>
  <div
      class="mensaje-contenedor"
      :class="{ 'mensaje-propio': esPropio, 'mensaje-ajeno': !esPropio }"
  >
    <div class="icono-wrapper" v-if="!esPropio">
      <em v-if="mostrarIcono" :class="{ 'icon_dentalia  icons-size mt-4': !esUsuarioLab, 'icon_laboratorio  icons-size mt-4': esUsuarioLab}"></em>
      <div v-else class="icono-placeholder"></div>
    </div>


    <div class="contenido-vertical">
      <p v-if="mostrarNombre" class="nombre-usuario">
        {{ usuario }} — {{ fecha }}
      </p>
      <div :class="['burbuja', posicion, esPropio ? 'enviado' : 'recibido']">
        <div class="contenido">
          <p v-html="mensajeConMenciones"></p>
          <img
              v-if="imagen !== null"
              :src="imagen"
              alt="img-chat"
              class="imagen-chat"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Mensaje",
  props: {
    mensaje: String,
    usuario: String,
    fecha: String,
    posicion: String,
    esPropio: Boolean,
    esUsuarioLab: Boolean,
    mostrarIcono: Boolean,
    mostrarNombre: Boolean,
    imagen: String,
  },
  data() {
    return {}
  },
  created() {
  },
  computed: {
    mensajeConMenciones() {
      return this.mensaje.replace(/(^|\s)(@\w+)/g, '$1<span class="mencion">$2</span>');
    }

  },
  methods: {}

}
</script>

<style>
.mencion {
  color: #0155A7;
  font-weight: 600;
}

.icono-wrapper {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-top: 3px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icono-placeholder {
  width: 100%;
  height: 100%;
  visibility: hidden;
}

.mensaje-contenedor {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}

.mensaje-propio {
  flex-direction: row-reverse;
}

.contenido-vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.mensaje-propio .contenido-vertical {
  align-items: flex-end;
  margin-right: 8px;
}

.nombre-usuario {
  font-size: 0.75rem;
  color: #555;
  margin-bottom: 4px;
  font-weight: 500;
}

.burbuja {
  padding: 0.5em 1em;
  max-width: 70%;
  min-width: 4em;
  margin-bottom: 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
}

.enviado {
  background-color: #d0e7ff;
  align-self: flex-end;
}

.recibido {
  background-color: #ffffff;
}

.burbuja.inicio.enviado {
  border-radius: 11px 11px 2px 11px;
  margin-top: 1%;
}

.burbuja.medio.enviado {
  border-radius: 11px;
}

.burbuja.fin.enviado {
  border-radius: 11px 2px 11px 11px;
}

.burbuja.solo.enviado {
  border-radius: 11px;
}

.burbuja.inicio.recibido {
  border-radius: 11px 11px 11px 2px;
  margin-top: 1%;
}

.burbuja.medio.recibido {
  border-radius: 11px;
  width: 100% !important;
}

.burbuja.fin.recibido {
  border-radius: 2px 11px 11px 11px;
}

.icono-usuario {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-top: 3px;
  flex-shrink: 0;
}

.imagen-chat{
  max-width: 100%;
}

.icons-size{
  width: 24px;
  height: 24px;
}

</style>
  